import React from "react";
import { View, TouchableOpacity, Image } from "react-native";
import { ProfileAvatar } from "../Image";
import { PrimaryTitle } from "../labels";
import { colors } from "../../const";

export default function SettingItem({ title, subtitle, right, avatar, icon, ...other }) {

    return (
        <>
            <TouchableOpacity
                activeOpacity={0.6}
                style={{
                    flexDirection: 'row',
                    paddingHorizontal: 10,
                    paddingVertical: 15,
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}
                {...other}>
                <View style={{
                    flexDirection: 'row',
                    alignItems: 'center'
                }}>
                    {
                        icon && (
                            <View style={{
                                width: 55,
                                height: 55,
                                marginLeft: 10,
                                justifyContent: "center",
                                alignItems: "center"
                            }}>
                                <Image
                                    source={icon}
                                    style={{ height: 28, width: 28, resizeMode: "contain" }}
                                />
                            </View>

                        )
                    }
                    {
                        avatar && (
                            <View style={{
                                width: 55,
                                height: 55,
                                marginLeft: 10
                            }}>
                                <ProfileAvatar src={avatar} size="70%" />
                            </View>
                        )
                    }
                    <View style={{ marginLeft: 20 }}>
                        <PrimaryTitle size={15}>
                            {title}
                        </PrimaryTitle>
                        <View style={{ height: 3 }} />
                        <PrimaryTitle size={13}>
                            {subtitle}
                        </PrimaryTitle>
                    </View>
                </View>
                {
                    right && right
                }
            </TouchableOpacity>
            <View style={{
                height: 1,
                backgroundColor: colors.lightGray,
                width: '100%'
            }} />
        </>
    )
}